module.exports = __webpack_public_path__ + "assets/main-logo-e719c1.svg";